export const INTERNAL_SERVER_ERROR_MESSAGE = 'Qualcosa è andato storto. Riprova in seguito.'